module.exports = __webpack_public_path__ + "media/components/guide-page/static/wave-background-014f68f7d29c9a2ccd971a9d82e930f2.svg";